import {
  ArrowRightIcon,
  Button,
  PageHeading,
  Paragraph,
  StethoscopeIcon,
} from '@quickmd-llc/design-system';
import { SERVICES_ROUTE_PATHNAME } from '@router/routes/routePathnames';
import { useRefillCheckup } from '../hooks/useRefillCheckup';
import { useApplicationStore } from '@data';

const initialSlideText = {
  heading: 'Let’s update your health status with a couple of questions.',
  body: 'We need to know how you’re progressing to be able to recommend an automatic refill.',
  button: 'Start',
};

const finalSlideText = {
  heading: 'You’ll need to see a doctor to continue your treatment.',
  body: 'Your current conditions don’t qualify for a refill. Please book a new visit to continue.',
  button: 'Book a Visit',
};

export function CheckupInfoSlideTemplate() {
  const { checkupFailed, nextSlide } = useRefillCheckup();
  const { patientProfile } = useApplicationStore.getState().patient;

  const text = checkupFailed ? finalSlideText : initialSlideText;
  const actionProps = checkupFailed
    ? {
        to: `${SERVICES_ROUTE_PATHNAME}?state=${patientProfile?.address.stateCode || ''}`,
      }
    : { onClick: nextSlide };

  return (
    <>
      <div className="flex flex-1 flex-col justify-center">
        {checkupFailed && (
          <div className="mb-4">
            <StethoscopeIcon size="2x" />
          </div>
        )}
        <PageHeading className="mb-6">{text.heading}</PageHeading>

        <Paragraph className="mb-4 font-medium text-shade-95">
          {text.body}
        </Paragraph>
      </div>

      <Button className="mt-auto w-full" {...actionProps}>
        {text.button}
        <ArrowRightIcon />
      </Button>
    </>
  );
}
